/* tslint:disable */

import { URI } from '@vscode/base-node/vs/base/common/uri';
import { TPromise } from '@vscode/base-node/vs/base/common/winjs.base';

export enum JSONEditingErrorCode {

	/**
	 * Error when trying to write and save to the file while it is dirty in the editor.
	 */
	ERROR_FILE_DIRTY,

	/**
	 * Error when trying to write to a file that contains JSON errors.
	 */
	ERROR_INVALID_FILE,
}

export interface IJSONValue {
	key: string;
	value: any;
}

export interface IJSONEditingService {

	write(resource: URI, value: IJSONValue, save: boolean): TPromise<void>;
}